import { useState } from "react";
import { Iconify } from "@repo/design-system/components/ui";
import { GridColumnType } from "@repo/design-system/components/grids";

const NotificationImageCell = ({ imageUrl, title }) => {
    const [imageError, setImageError] = useState(false);

    if (!imageUrl || imageError) {
        return (
            <div className="view-student-notification-image-placeholder">
                <Iconify icon="lucide:bell" width={22} />
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            alt={title || "Notification"}
            className="view-student-notification-image"
            onError={() => setImageError(true)}
        />
    );
};

export const createViewStudentNotificationGridConfig = ({ onViewImage } = {}) => ({
    name: "Student Notifications",
    filtersConfig: {
        enabled: true,
        placeholder: "Search by title or description",
        mainDivClass: "col-xl-4 col-md-6 ml-auto",
    },
    columns: [
        {
            field: "url",
            header: "Image",
            width: "8%",
            disableOverflow: true,
            body: (rowData) => {
                const imageUrl = rowData?.url;
                if (!imageUrl) {
                    return (
                        <div className="view-student-notification-image-cell">
                            <NotificationImageCell imageUrl={imageUrl} title={rowData?.title} />
                        </div>
                    );
                }

                // Same interaction as the admin StudentNotificationGrid's image column —
                // click opens the full image in a right-side SidebarModal.
                return (
                    <div
                        className="view-student-notification-image-cell view-student-notification-image-clickable"
                        onClick={(e) => {
                            e.stopPropagation();
                            onViewImage?.(imageUrl, rowData);
                        }}
                        title="Click to view image"
                    >
                        <NotificationImageCell imageUrl={imageUrl} title={rowData?.title} />
                        <div className="view-student-notification-image-hover-overlay">
                            <Iconify icon="lucide:eye" width={16} height={16} />
                        </div>
                    </div>
                );
            },
        },
        {
            field: "title",
            header: "Title",
            width: "20%",
            config: { sortable: true },
        },
        {
            field: "description",
            header: "Description",
            width: "60%",
            // Same as the admin StudentNotificationGrid's description column — leaving overflow
            // enabled (the default) is what makes OverflowCell show a tooltip with the full text
            // when it's truncated.
            disableOverflow: false,
        },
        {
            field: "actions",
            header: "Action",
            width: "12%",
            type: GridColumnType.ACTION,
            defaultActions: { VIEW: true },
        },
    ],
});
